const EXAMPLE_PREFIX = /^bijv(?:oorbeeld)?\.?\s*/i;

/**
 * A placeholder is announced as the field's current value. Keep an example in the
 * hint instead, and keep at most one hint: an authored hint wins over the example.
 */
export const spokenFieldHint = (hint?: string | null, placeholder?: string | null): string | undefined => {
  const trimmedHint = hint?.trim() ?? '';
  if (trimmedHint) return trimmedHint;

  const example = placeholder?.trim().replace(EXAMPLE_PREFIX, '') ?? '';
  if (!example) return undefined;

  return `Bijvoorbeeld ${example}`;
};
